/**
 * Question constants
 *
 * @author Matthew Rawson @ 13/02/2018 14:25
 * @type {string}
 */
export const ENABLED = "enabled"
export const DISABLED = "disabled"

export const STATUSES = [ENABLED, DISABLED]

export const TYPE_LIKERT = "likert"
export const TYPE_DRIVER = "driver"

export const TYPES = [TYPE_LIKERT, TYPE_DRIVER]

export const DEFAULT_DRIVER_ENGAGEMENT_QUESTION_TEXT = "" +
  "Your call. Is there one area you'd like to give us more feedback on?"

export const INTRO_STARTED = "INTRO_STARTED"
export const INTRO_COMPLETE = "INTRO_COMPLETE"
export const OUTRO_STARTED = "OUTRO_STARTED"
export const OUTRO_COMPLETE = "OUTRO_COMPLETE"
export const TRIGGER_OUTRO = "TRIGGER_OUTRO"
export const TRANSITION_STATES = [TRIGGER_OUTRO, INTRO_STARTED, INTRO_COMPLETE, OUTRO_STARTED, OUTRO_COMPLETE]

export const DIRECTION_FORWARD = "DIRECTION_FORWARD"
export const DIRECTION_BACKWARDS = "DIRECTION_BACKWARDS"
export const DIRECTIONS = [DIRECTION_FORWARD, DIRECTION_BACKWARDS]

export const DELETED_GROUP_ID = "11111111-1111-1111-1111-111111111111"
export const CLONE_STATUS_NEW = "new"
export const CLONE_STATUS_DELETED = "deleted"

export const QUESTION_EDIT_MODE = "edit"
export const QUESTION_DELETE_MODE = "delete"
export const QUESTION_LIST_MODE = "list"
